import { render, staticRenderFns } from "./create-employee.vue?vue&type=template&id=9b9d310a&scoped=true&"
import script from "./create-employee.vue?vue&type=script&lang=js&"
export * from "./create-employee.vue?vue&type=script&lang=js&"
import style0 from "./create-employee.vue?vue&type=style&index=0&id=9b9d310a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9d310a",
  null
  
)

export default component.exports